<template>
  <MediaForm
    v-if="!isLoading"
    :initial-media="media"
    @saved="$emit('saved')"
    @cancel="$emit('cancel')"
  />
  <div v-else class="flex items-center justify-center py-8">
    <Spinner class="text-hazel-600" />
  </div>
</template>

<script lang="ts" setup>
import Spinner from '@/components/icons/Spinner.vue';
import { useMedia } from '@/queries/use-media';
import MediaForm from './MediaForm.vue';

const props = defineProps<{
  mediaId: string | null;
}>();

defineEmits<{
  (e: 'saved'): void;
  (e: 'cancel'): void;
}>();

const { data: media, isLoading } = useMedia(props.mediaId);
</script>
